// Decoupled event bus so any flow can open feedback or raise a contextual prompt
// without the Feedback widget needing to be wired through props.
export function openFeedback(detail = {}) {
  window.dispatchEvent(new CustomEvent("pmfeedback:open", { detail }));
}

// detail: { trigger, title, question, simId }
export function promptFeedback(detail = {}) {
  if (!detail.trigger) return;
  const key = `pmfb_${detail.simId || "global"}_${detail.trigger}`;
  if (localStorage.getItem(key)) return; // already answered/skipped this run
  window.dispatchEvent(new CustomEvent("pmfeedback:prompt", { detail }));
}

export function markPromptDone(simId, trigger) {
  localStorage.setItem(`pmfb_${simId || "global"}_${trigger}`, "1");
}
